import React, { useEffect, useRef } from "react";
import useResizeObserver from "../../../hooks/useResizeObserver";
import usePageFiltersOpenState from "../../../hooks/usePageFiltersOpenState";
import {
    isMobileHorizontalScreen,
    isMobileScreen,
} from "../../../utils/displayUtils";

export default function FiltersCard({ containerEl, containerRef, renderContent }) {
    const closeTimerRef = useRef(null);
    const scrollContainerRef = useRef(null);
    const isLandscapeMobile = isMobileHorizontalScreen();
    const isMobile = isMobileScreen();
    const {
        isOpen,
        isOpenByHover,
        setPersistedOpen,
        setTemporaryOpen,
    } = usePageFiltersOpenState();

    const clearCloseTimer = () => {
        if (!closeTimerRef.current) {
            return;
        }

        clearTimeout(closeTimerRef.current);
        closeTimerRef.current = null;
    };

    useEffect(() => {
        return () => {
            clearCloseTimer();
        };
    }, []);

    const observer = useResizeObserver(containerEl);
    const filtersPanelWidth = observer?.width || 0;
    const inputMinWidth = filtersPanelWidth ? filtersPanelWidth - 30 : undefined;
    const defaultInputStyle = {
        root: { minWidth: inputMinWidth, flexGrow: "0", padding: "0px" },
        chip: { maxWidth: isMobile ? null : "160px" },
        input: { height: 0 },
        paper: {position: "relative", maxHeight: 250},
    };
    const landscapeInputStyle = {
        root: { minWidth: "30vw", width: "auto", flexGrow: "1", padding: "0px" },
        input: { height: 0 },
        paper: { maxHeight: 150 },
    };

    const openByHover = () => {
        if (isOpen) {
            return;
        }
        clearCloseTimer();
        setTemporaryOpen(true);
    };

    const resetTimer = () => {
        clearCloseTimer();
    };

    const closeWithTimer = () => {
        if (!isOpenByHover) {
            return;
        }

        clearCloseTimer();
        closeTimerRef.current = setTimeout(() => {
            setTemporaryOpen(false);
            closeTimerRef.current = null;
        }, 3000);
    };

    const filtersClassName = !isOpen
        ? "filters"
        : "filters open" + (isLandscapeMobile ? " filter-popup" : "");
    const resolvedInputStyle = isLandscapeMobile ? landscapeInputStyle : defaultInputStyle;

    const inputProps = {
        inputStyle: resolvedInputStyle,
        itemMinWidth: inputMinWidth,
        scrollContainerRef,
    };

    const isLandscapePopup = isLandscapeMobile;
    const shouldDisplayHoverTrigger = !isMobile && !isLandscapePopup && !isOpen;
    const filtersContent = renderContent(inputProps);

    if (!filtersContent) {
        return null;
    }

    return (
        <>
            <div
                className={filtersClassName}
                ref={containerRef}
                onMouseLeave={closeWithTimer}
                onMouseMove={resetTimer}
            >
                <div className="nav-filter" ref={scrollContainerRef}>
                    {filtersContent}
                    {isLandscapePopup && (
                        <button
                            className="closeButton"
                            onClick={() => setPersistedOpen(!isOpen)}
                        >
                            <i className="ti ti-close"/>
                        </button>
                    )}

                </div>
            </div>
            {shouldDisplayHoverTrigger && (
                <div className="empty-filters-block" onMouseMove={openByHover} />
            )}
        </>
    );

}
